<template>
    <iframe v-if="address" class="map" frameborder="0" :src="'https://www.google.com/maps/embed/v1/place?key=' + googleKey + '&q=' + address"></iframe>
</template>
<script>
export default {
  name: "Map",
  props: {
      address: String,
      googleKey: String
    }
};
</script>
<style lang="scss" scoped>
.map {
    width: 100%;
    height: 25rem;
}
</style>